import { useState, useCallback } from 'react';

export const useAuthPrompt = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [feature, setFeature] = useState('default');
  const [title, setTitle] = useState(null);

  const showAuthPrompt = useCallback((featureOrTitle = 'default', options = {}) => {
    // If passing a custom title (for dynamic messages)
    if (options.isTitle) {
      setTitle(featureOrTitle);
      setFeature('default');
    } else {
      // Otherwise use feature-based messages
      setFeature(featureOrTitle);
      setTitle(null);
    }
    setIsOpen(true);
  }, []);

  const hideAuthPrompt = useCallback(() => {
    setIsOpen(false);
    // Reset states when closing
    setTitle(null);
    setFeature('default');
  }, []);

  return {
    isOpen,
    feature,
    title,
    showAuthPrompt,
    hideAuthPrompt
  };
};